import Swiper, { Navigation, Pagination, Manipulation } from "swiper";

import { IContext } from "@src/context";
import { addFavoriteItem, removeFavoriteItem } from "@src/utils/favorite";
import { fetchFavoritedProperties } from "./fetch";
import { renderSlides } from "./slides";
import {
  getPropertyIdsFromSlides,
  pushViewItemListEventFromSlides,
  pushSelectItemEventFromId,
} from "./analytic";

import "./index.css";

export function setupShortList(context: IContext) {
  const container = document.querySelector(".container-shortlist");

  if (container == null) {
    return;
  }

  // add slides
  fetchFavoritedProperties(context).then((properties) => {
    // init swiper
    const swiper = new Swiper(".container-shortlist-swiper", {
      slidesPerView: 1,
      spaceBetween: 32,
      autoHeight: true,
      loop: properties.length >= 6, // loop only if there are more than slidesPerView * 2 slides
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1104: {
          slidesPerView: 3,
          spaceBetween: 48,
        },
      },
      modules: [Navigation, Pagination, Manipulation],
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });

    // clear slides
    swiper.removeAllSlides();

    const slides = renderSlides(context, properties);

    if (slides.length > 0) {
      slides.forEach((slide) => {
        swiper.appendSlide(slide);
      });
      container.removeAttribute("data-empty");
    } else {
      container.setAttribute("data-empty", "true");
    }

    // GTM push `view_item_list` event when first load list
    pushViewItemListEventFromSlides(getVisibleSlides(swiper.activeIndex));

    // init previous slides
    let perviousPropertyIds = getPropertyIdsFromSlides(
      getVisibleSlides(swiper.activeIndex)
    );
    // slide change
    swiper.on("slideChangeTransitionEnd", function () {
      const currentSlides = getVisibleSlides(swiper.activeIndex);
      // GTM push `view_item_list` event when slide change
      pushViewItemListEventFromSlides(
        // exclude previous slides
        currentSlides.filter(
          (slide: HTMLElement) =>
            !perviousPropertyIds.includes(getPropertyIdsFromSlides([slide])[0])
        )
      );
      // update previous slides
      perviousPropertyIds = getPropertyIdsFromSlides(currentSlides);
    });

    function getVisibleSlides(activeIndex: number) {
      return swiper.slides.slice(
        activeIndex,
        activeIndex +
          (typeof swiper.params.slidesPerView === "number"
            ? swiper.params.slidesPerView
            : 0)
      );
    }
  });

  // GTM push `select_item` event
  container.addEventListener("click", function (e) {
    const source = e.target as HTMLElement;
    if (
      (source && source.classList.contains("container-shortlist-item-link")) ||
      source.closest(".container-shortlist-item-image a")
    ) {
      const propertyId = source
        .closest(".container-shortlist-item")
        ?.querySelector(".container-shortlist-favorite")
        ?.getAttribute("data-property-id");
      pushSelectItemEventFromId(propertyId || "");
    }
  });

  // toggle favorite
  container.addEventListener("click", (event) => {
    if (event.target instanceof HTMLElement) {
      const btn = event.target.closest(".container-shortlist-favorite");
      const propertyId = btn?.getAttribute("data-property-id");
      if (btn && propertyId) {
        if (btn.getAttribute("data-favorite") === "true") {
          // remove from favorite
          btn.setAttribute("data-favorite", "false");
          removeFavoriteItem(propertyId);
        } else {
          // add to favorite
          btn.setAttribute("data-favorite", "true");
          addFavoriteItem(propertyId);
        }
      }
    }
  });
}
